(() => {
  const sourceKey = 'furllo-product-source';
  const restoreKey = 'furllo-scroll-restore';
  const safeRead = key => { try { return JSON.parse(sessionStorage.getItem(key)); } catch { return null; } };
  const safeWrite = (key, value) => { try { sessionStorage.setItem(key, JSON.stringify(value)); } catch {} };
  const sameOrigin = value => { try { return new URL(value, location.origin).origin === location.origin; } catch { return false; } };
  document.addEventListener('click', event => {
    const back = event.target.closest('[data-furllo-product-back]');
    if (back) {
      const source = safeRead(sourceKey);
      if (source && sameOrigin(source.url) && Date.now() - source.time < 86400000 && source.url !== location.href) {
        event.preventDefault();
        safeWrite(restoreKey, source);
        if (document.referrer === source.url && history.length > 1) history.back();
        else location.assign(source.url);
      } else if (document.referrer && sameOrigin(document.referrer) && history.length > 1) {
        event.preventDefault();
        history.back();
      }
      return;
    }
    const link = event.target.closest('a[href]');
    if (!link || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || link.target === '_blank') return;
    const url = new URL(link.href, location.origin);
    if (url.origin === location.origin && url.pathname.includes('/products/')) safeWrite(sourceKey, { url: location.href, y: scrollY, time: Date.now() });
  });
  const restore = () => {
    const target = safeRead(restoreKey);
    if (!target || target.url !== location.href) return;
    try { sessionStorage.removeItem(restoreKey); } catch {}
    requestAnimationFrame(() => scrollTo({ top: target.y, behavior: 'instant' }));
    setTimeout(() => scrollTo({ top: target.y, behavior: 'instant' }), 180);
  };
  window.addEventListener('pageshow', restore);
})();


(() => {
  document.addEventListener('click', event => {
    document.querySelectorAll('details.atelier-mobile[open]').forEach(menu => {
      if (menu.querySelector('summary')?.contains(event.target)) return;
      const withinMenu = menu.contains(event.target);
      menu.open = false;
      if (!withinMenu) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    });
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('details.atelier-mobile[open]').forEach(menu => {
      menu.open = false;
      menu.querySelector('summary')?.focus();
    });
  });
})();
